<div class="d-flex flex-column min-vh-100">
  <div class="row flex-grow-1">
    <div class="col-lg-2 mt-5">
      <zero-waste-side></zero-waste-side>
    </div>
    <div class="col-lg-10">
      <router-outlet />
    </div>
  </div>

  <zero-waste-footer></zero-waste-footer>
</div>
